import styled from 'styled-components'

// Mobile-number cell — copies to the clipboard on click instead of opening the row.
export const CopyText = styled.span`
	cursor: copy;
	text-decoration: underline dotted;
	text-underline-offset: 2px;
`
